import { render } from "./DevisDetailPage.vue?vue&type=template&id=cbc646c8&scoped=true&ts=true"
import script from "./DevisDetailPage.vue?vue&type=script&lang=ts"
export * from "./DevisDetailPage.vue?vue&type=script&lang=ts"

import "./DevisDetailPage.vue?vue&type=style&index=0&id=cbc646c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc646c8"]])

export default __exports__